import ReactGA from 'react-ga'
import React from 'react'
// Import Sections
import Hero from '../Views/Home/Hero'
import MapStory from '../Views/Home/MapStory'
import FeaturesTwo from '../Views/Home/FeaturesTwo'
import FeaturesBordered from '../Views/Home/FeaturesBordered'
import { steps } from './steps'

const location = [
  {
    key: 'hero',
    component: Hero,
    color: 'LIGHT',
    shadow: true,
    main: {
      h: <img src="/publicAssets/foam-location-2-line.svg" alt="" />,
      p:
        'A permissionless and autonomous network of radios that offer secure location services through time synchronization, independent of centralized sources like GPS.',
      cta: [
        {
          path: 'https://foam.space/publicAssets/FOAM_Whitepaper.pdf',
          text: <img src="/publicAssets/btnLocation.svg" alt="" />,
          type: 'EXTERNAL-IMAGE',
          new: false,
          onClickHandler: () =>
            ReactGA.event({
              category: 'cta_click',
              action: 'home_start_mapping'
            })
        }
      ],
      justification: 'LEFT',
      width: 'NARROW'
    },
    video: {
      src: '/bigAssets/Foam_15sec.mp4',
      alt: 'Your browser does not support the video tag.'
    }
  },
  {
    key: 'featuresTwo',
    component: FeaturesTwo,
    color: 'LIGHT',
    main: [
      {
        h: 'Host the future of location data.',
        p:
          'A community owned and operated network. Service providers are rewarded for setting up and maintaining radio beacons.',
        img: <img src="/publicAssets/icons/location_1.svg" alt="" />
      },
      {
        h: 'Own your location network.',
        p:
          'The FOAM token grants the right to offer location services and safety deposits ensure service providers can be trusted.',
        img: <img src="/publicAssets/icons/location_2.svg" alt="" />
      },
      {
        h: 'A fault-tolerant system.',
        p:
          'Location customers receive accurate and secure location data even when part of the network is down.',
        img: <img src="/publicAssets/icons/location_3.svg" alt="" />
      },
      {
        h: 'Low power. Long range.',
        p:
          'FOAM Location is optimized for Low-Power Wide-Area Network technology that cover large distances with minimal power consumption.',
        img: <img src="/publicAssets/icons/location_4.svg" alt="" />
      }
    ]
  },
  {
    key: 'mapStory',
    component: MapStory,
    color: 'DARK',
    main: {
      h: 'Foam is Cartography, Cryptographically.',
      p:
        'We are designing a shared spatial language for open decentralized systems and smart contracts. FOAM is working on geospatial protocol and the resulting market implications on global infrastructures.',
      cta: {
        path: 'https://blog.foam.space/',
        text: 'Learn More on Our Blog',
        type: 'EXTERNAL'
      },
      icn: { src: '/publicAssets/icons/intro.png', alt: '' },
      justification: 'LEFT',
      width: 'NARROW'
    },
    sub: {
      h: '',
      p: '',
      cta: { path: '', text: '', type: '' },
      justification: 'LEFT',
      width: 'WIDE'
    },
    steps: steps
  },
  {
    key: 'featuresBordered',
    component: FeaturesBordered,
    color: 'DARK',
    shadow: true,
    h: 'How do I participate in FOAM Location?',
    main: [
      {
        h: 'Signal.',
        color: '#FFC700',
        p:
          'Create a signal on the FOAM Map to show where you need decentralized location services most. Signals hold FOAM Tokens in smart contracts linked to a particular area. This indicates the demand for location services and incentivizes participants to expand the coverage of FOAM Location.',
        cta: {
          href: 'https://map.foam.space',
          text: ['map.foam.space']
        }
      },
      {
        h: 'Offer location services.',
        color: '#27AE60',
        p:
          'To become a location service provider you need to host radio hardware (LPWAN) and stake a safety deposit of FOAM tokens. A safety deposit of FOAM tokens ensures that everyone follows the rules of offering location services. You will receive FOAM tokens and fees for verifying the locations of customers and for providing work for the network.',
        cta: {
          href: 'https://cqnllvd8gl2.typeform.com/to/EKlKIoEe',
          text: ['Sign up to be notified for the next batch']
        }
      }
    ]
  }
]

export { location }



// WEBPACK FOOTER //
// ./src/content/locationPage.js